import { Component } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';

@Component({
    selector: 'app-upcoming-trip-listing',
    templateUrl: './upcoming-trip-listing.component.html',
    styleUrls: ['./upcoming-trip-listing.component.scss'],
    imports: [MatTabGroup, MatTab]
})
export class UpcomingTripListingComponent {

}
